import { gql } from "@apollo/client";
import {
  SubscriptionPlan,
  PartnerSubscription,
  PlanUsage,
  CheckoutSessionResult,
  BillingPortalResult,
  SubscriptionHistoryItem,
} from "./models";

// Query types
export type GetSubscriptionPlansResponse = {
  getSubscriptionPlans: SubscriptionPlan[];
};

export type GetMySubscriptionResponse = {
  getMySubscription: PartnerSubscription | null;
};

export type GetPlanUsageResponse = {
  getPlanUsage: PlanUsage;
};

// Mutation types
export type CreateSubscriptionCheckoutResponse = {
  createSubscriptionCheckout: CheckoutSessionResult;
};

export type CreateSubscriptionCheckoutVariables = {
  planType: string;
  billingInterval?: string;
};

export type UpgradeSubscriptionResponse = {
  upgradeSubscription: PartnerSubscription;
};

export type UpgradeSubscriptionVariables = {
  newPlanType: string;
  billingInterval?: string;
};

export type CancelSubscriptionResponse = {
  cancelSubscription: PartnerSubscription;
};

export type ReactivateSubscriptionResponse = {
  reactivateSubscription: PartnerSubscription;
};

export type ManageBillingResponse = {
  manageBilling: BillingPortalResult;
};

export type GetSubscriptionHistoryResponse = {
  getSubscriptionHistory: SubscriptionHistoryItem[];
};

// Queries
export const GET_SUBSCRIPTION_PLANS = gql`
  query GetSubscriptionPlans {
    getSubscriptionPlans {
      key
      name
      maxUsers
      maxBranches
      maxOrdersPerMonth
      priceYearly
      priceMonthly
    }
  }
`;

export const GET_MY_SUBSCRIPTION = gql`
  query GetMySubscription {
    getMySubscription {
      id
      status
      plan_type
      interval
      period_start
      period_end
      cancel_at_period_end
      stripe_subscription_id
      amount
    }
  }
`;

export const GET_PLAN_USAGE = gql`
  query GetPlanUsage {
    getPlanUsage {
      currentUsers
      maxUsers
      currentBranches
      maxBranches
      currentOrders
      maxOrders
      isOnTrial
      trialDaysRemaining
    }
  }
`;

export const GET_SUBSCRIPTION_HISTORY = gql`
  query GetSubscriptionHistory {
    getSubscriptionHistory {
      id
      status
      plan_type
      amount
      payment_type
      date_created
      period_start
      period_end
    }
  }
`;

// Mutations
export const CREATE_SUBSCRIPTION_CHECKOUT = gql`
  mutation CreateSubscriptionCheckout($planType: PlanType!, $billingInterval: String) {
    createSubscriptionCheckout(planType: $planType, billingInterval: $billingInterval) {
      url
      session_id
    }
  }
`;

export const UPGRADE_SUBSCRIPTION = gql`
  mutation UpgradeSubscription($newPlanType: PlanType!, $billingInterval: String) {
    upgradeSubscription(newPlanType: $newPlanType, billingInterval: $billingInterval) {
      id
      status
      plan_type
      period_start
      period_end
      cancel_at_period_end
      amount
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription {
    cancelSubscription {
      id
      status
      cancel_at_period_end
    }
  }
`;

export const REACTIVATE_SUBSCRIPTION = gql`
  mutation ReactivateSubscription {
    reactivateSubscription {
      id
      status
      cancel_at_period_end
    }
  }
`;

export const MANAGE_BILLING = gql`
  mutation ManageBilling {
    manageBilling {
      url
    }
  }
`;
